"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDownstreamNameFromAction = void 0;
/**
 * Utility function to get downstream name from action
 * e.g action: 'meetingAsHost' would return downstream name: 'meeting as host' * @param actionName
 * @returns {*|string}
 */
var getDownstreamNameFromAction = exports.getDownstreamNameFromAction = function getDownstreamNameFromAction(actionName) {
  return actionName.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
};